/* Exact plant selections; Shopify owns component stock, discount and checkout. */
(() => {
  'use strict';
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const locale = (document.documentElement.lang || 'en').split('-')[0];
  const tr = (text, values = {}) => { let value = window.OsnCuratedCopy?.[locale]?.[text] || text; for (const [key, replacement] of Object.entries(values)) value = value.replaceAll('{{ '+key+' }}', replacement); return value; };
  document.querySelectorAll('.osn-curated').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const cards = [...section.querySelectorAll('.plant')];
    const button = section.querySelector('[data-add]');
    const state = section.querySelector('[data-selection-state]');
    const money = cents => new Intl.NumberFormat(locale === 'fr' ? 'fr-CA' : locale === 'es' ? 'es-CA' : 'en-CA', {style:'currency',currency:section.dataset.currency || 'CAD'}).format(cents / 100);
    let busy = false;
    const selection = () => {
      const selected = cards.filter(c => c.querySelector('input').checked && !c.querySelector('input').disabled);
      const full = selected.length === cards.length && section.dataset.complete === 'true';
      const subtotal = selected.reduce((n,c) => n + Number(c.dataset.price) * Number(c.dataset.quantity), 0);
      return {selected,full,subtotal,total:full ? Math.round(subtotal * .95) : subtotal};
    };
    const update = () => {
      const s = selection(), count = s.selected.reduce((n,c) => n + Number(c.dataset.quantity), 0);
      section.querySelector('[data-selection-total]').textContent = tr('{{ count }} plants · {{ amount }} CAD', {count, amount:money(s.total)});
      state.textContent = s.full ? tr('Complete collection · save {{ amount }} in your cart', {amount:money(s.subtotal - s.total)}) : tr('Individual selection · ordinary plant prices');
      button.textContent = `${s.full ? tr('Add collection') : tr('Add selected plants')} · ${money(s.total)}`;
      button.disabled = busy || !s.selected.length;
      cards.forEach(c => c.classList.toggle('excluded', !c.querySelector('input').checked));
    };
    cards.forEach(c => c.querySelector('input').addEventListener('change', update));
    button.addEventListener('click', async () => {
      if (busy) return;
      const s = selection();
      if (!s.selected.length) return;
      busy = true;button.disabled = true;state.textContent = tr('Adding your plants…');
      // One request, no automatic retries: a timeout could follow a successful add.
      const items = s.full ? [{id:Number(section.dataset.bundle),quantity:1}] : s.selected.map(c => ({id:Number(c.dataset.variant),quantity:Number(c.dataset.quantity)}));
      let added = false;
      try {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const sections = cart?.getSectionsToRender().map(s => s.id) || [];
        cart?.setActiveElement?.(button);
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections,sections_url:window.location.pathname})});
        const result = await response.json();
        if (!response.ok) {
          // Shopify may partially accept a multi-add. Reconcile in cart before retrying.
          throw new Error(tr('We could not confirm the cart response.'));
        }
        added = true;
        const first = result.items?.[0] || result;
        if (!cart || !result.sections || Object.values(result.sections).some(s => s === null)) {
          throw new Error(tr('Added to your cart, but the cart display could not refresh.'));
        }
        cart.renderContents({...result,key:first.key});
        cart.classList.remove('is-empty');
        window.refreshOsnCardCartState?.();
        busy = false;update();
        state.textContent = s.full ? tr('Collection added to your cart.') : tr('Selected plants added to your cart.');
      } catch (error) {
        state.textContent = `${added ? tr('Added to your cart, but the cart display could not refresh.') : (error.message || tr('We could not confirm the cart response.'))} ${tr('Check your cart before adding again.')}`;
        const link = document.createElement('a');link.href=root+'cart';link.textContent=' '+tr('View cart →');state.appendChild(link);
        button.textContent=tr('Check cart');button.disabled=true;
      }
    });
    const dialog = section.querySelector('dialog');
    dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
    section.querySelectorAll('[data-gallery]').forEach(photo => photo.addEventListener('click', () => {
      const d = photo.dataset;
      dialog.querySelector('.gallery-title').textContent=d.name;
      dialog.querySelector('.gallery-product').href=d.product;
      const show = view => {
        const img=dialog.querySelector('img');img.src=(view==='main'?d.main:d.reference)+'&width=1400';
        img.alt=d.name;dialog.querySelector('.gallery-caption').textContent=view==='main'?d.caption:tr('Nursery reference. This collection supplies large plugs.');
        dialog.querySelectorAll('[data-view]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.view===view)));
      };
      dialog.querySelectorAll('[data-view]').forEach(b => {b.onclick=()=>show(b.dataset.view);});
      show('main');dialog.showModal();
    }));
    update();
  });
})();
